"use client";

import Image from "next/image";
import React, { useState } from "react";
import { twMerge } from "tailwind-merge";

import { BREAKPOINTS } from "@/globals";
import { getAncillaryAsset } from "@/raabits/constants";
import { type RProductType } from "@/schemes/raabits.scheme";
import { TYPO_STYLES } from "@/styles/typography";
import { VIEWPORT_STYLES } from "@/styles/viewport";

export const ProductImageView = ({ product }: { product: RProductType }) => {
    const file = product.metadata.dateien.deckblatt || product.metadata.dateien.coverbild;
    const imageUrl = file && getAncillaryAsset(product.key, file);

    const [openModal, setOpenModal] = useState(false);

    const handleOpen: React.MouseEventHandler<HTMLButtonElement> = (): void => {
        setOpenModal(true);
    };

    const handleClose: React.MouseEventHandler<HTMLButtonElement> = (): void => {
        setOpenModal(false);
    };

    if (imageUrl) {
        return (
            <div className="relative">
                <Image
                    src={imageUrl}
                    alt={product.metadata?.erstertitelteil}
                    title={product.metadata?.erstertitelteil}
                    width={1000}
                    height={1414}
                    priority
                    className="w-full h-auto"
                    sizes={`(min-width: ${BREAKPOINTS.md}px) ${BREAKPOINTS.md}px, (min-width: ${BREAKPOINTS.lg}px) ${BREAKPOINTS.lg}px, 100vw`}
                />
                <button
                    className="bg-brandDark h-11 w-11 rounded-md absolute bottom-3 right-3 flex justify-center items-center"
                    onClick={handleOpen}
                >
                    <span className={twMerge(TYPO_STYLES.icon(), "text-white text-3xl")}>
                        {String.fromCharCode(Number("0xe953"))}
                    </span>
                </button>
                {openModal && (
                    <button
                        className="bg-backgroundModal fixed left-0 top-0 bottom-0 p-8 right-0 z-50  overflow-y-auto"
                        onClick={handleClose}
                    >
                        <Image
                            src={imageUrl}
                            alt={product.metadata?.erstertitelteil}
                            title={product.metadata?.erstertitelteil}
                            width={1000}
                            height={1414}
                            className={`w-full h-auto ${VIEWPORT_STYLES.viewport()}`}
                            sizes={`100vw`}
                        />
                    </button>
                )}
            </div>
        );
    } else {
        return null;
    }
};
